import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

/**
 * ACTO chrome shell: fixed sidebar rail + top bar + scrolling content area.
 * Rendered as the element of the authenticated route group; feature pages land
 * in the <Outlet />.
 */
export function Layout() {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-background text-foreground">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Header />
        <main className="flex-1 overflow-y-auto p-3 md:p-6" data-testid="app-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
